const {React} = require('react');

const extractGlobalEdges = (references, globalEdges) => {
  const referenceIDs = extractIDs(references);

  let matchedEdges = [];

  if(globalEdges && globalEdges.edges.length > 0) {
    matchedEdges = globalEdges.edges.filter(edge => {
      return referenceIDs.includes(edge.node.contentful_id)
    });  
  }

  return matchedEdges;
}

const extractGlobalNodes = (references, globalNodes) => {
  const referenceIDs = extractIDs(references);

  let matchedNodes = [];

  if(globalNodes && globalNodes.nodes.length > 0) {
    matchedNodes = globalNodes.nodes.filter(node => {
      return referenceIDs.includes(node.contentful_id)
    });  
  }

  return matchedNodes;
}

const extractIDs = (references) => {
  let referenceIDs = [];

  if(references) {
    referenceIDs = references.map(reference => {
      const urn = reference?.sys?.urn;
      
      if(urn) {
        const lastIndex = urn.lastIndexOf('/');
        const id = urn.substring(lastIndex + 1);  
        return id;  
      }
    });  
  }

  return referenceIDs;
}
  
module.exports.extractGlobalEdges = extractGlobalEdges;
module.exports.extractGlobalNodes = extractGlobalNodes;
module.exports.extractIDs = extractIDs;